import { createSlice } from "@reduxjs/toolkit";

const ActiveColumnSlice = createSlice({
    name: "ActiveColumn",
    initialState: "",
    reducers: {
        setActiveColumn: (state, action) => {
            return action.payload
        },
    },
});

export const { setActiveColumn } = ActiveColumnSlice.actions;

export default ActiveColumnSlice.reducer;